import { getData } from "../helpers";
import { CustomerModal } from "../views/admin/sales/customers/modals/store";

class ButtonCustomer extends HTMLButtonElement {
    connectedCallback() {
        this.test();
        this.load();
        this.events();
    }

    test() {
        // No borrar este método, pero sí su contenido
    }

    load() {
        //
    }

    events() {
        this.addEventListener("click", (e) => {
            CustomerModal.create(
                getData(this, "data-bs-target"),
                getData(this, "title"),
                getData(this, "data-url")
            );
        });
    }
}

window.customElements.define("button-customer", ButtonCustomer, {
    extends: "button",
});
